import { eJournalEntryType } from './eJournalEntryType';
import { ISelectOption } from '../../ui-toolkit';

export enum eJournalEntryPaymentMethod {
  ACH = 'ACH',
  CHECK = 'CHECK',
  INTERNAL_TRANSFER = 'INTERNAL_TRANSFER',
  MANUAL_CHECK = 'MANUAL_CHECK',
  WIRE = 'WIRE',
}

export const prettyJournalEntryPaymentMethod: Record<eJournalEntryPaymentMethod, string> = {
  ACH: 'ACH',
  CHECK: 'Check',
  MANUAL_CHECK: 'Manual Check',
  INTERNAL_TRANSFER: 'Internal Transfer',
  WIRE: 'Wire',
};

export const prettyJournalEntryPaymentMethodType: Record<eJournalEntryType, string> = {
  CREDIT: 'Deposit',
  DEBIT: 'Disbursement',
};

export interface IPaymentMethodEntryTypeValue {
  paymentMethod: eJournalEntryPaymentMethod;
  entryType: eJournalEntryType | null;
}

const getPaymentMethodLabel = ({ paymentMethod, entryType }: IPaymentMethodEntryTypeValue): string => {
  const prefix =
    paymentMethod === eJournalEntryPaymentMethod.CHECK && entryType === eJournalEntryType.DEBIT ? 'Automated ' : '';
  return (
    prefix +
    prettyJournalEntryPaymentMethod[paymentMethod] +
    (!!entryType ? ' ' : '') +
    (!!entryType ? prettyJournalEntryPaymentMethodType[entryType] : '')
  );
};

//FYI: this returns a pre-sorted (non-alphabetical) list
export const createJournalEntryPaymentMethodOptions: ISelectOption<IPaymentMethodEntryTypeValue>[] = [
  { paymentMethod: eJournalEntryPaymentMethod.ACH, entryType: eJournalEntryType.CREDIT },
  { paymentMethod: eJournalEntryPaymentMethod.WIRE, entryType: eJournalEntryType.CREDIT },
  { paymentMethod: eJournalEntryPaymentMethod.CHECK, entryType: eJournalEntryType.CREDIT },
  { paymentMethod: eJournalEntryPaymentMethod.ACH, entryType: eJournalEntryType.DEBIT },
  { paymentMethod: eJournalEntryPaymentMethod.WIRE, entryType: eJournalEntryType.DEBIT },
  { paymentMethod: eJournalEntryPaymentMethod.CHECK, entryType: eJournalEntryType.DEBIT },
  { paymentMethod: eJournalEntryPaymentMethod.MANUAL_CHECK, entryType: eJournalEntryType.DEBIT },
  { paymentMethod: eJournalEntryPaymentMethod.INTERNAL_TRANSFER, entryType: null }, //FYI: null here means IT can be CREDIT or DEBIT
].map((value) => ({
  value,
  label: getPaymentMethodLabel(value),
}));

//FYI: this returns a pre-sorted (non-alphabetical) list
export const journalEntryPaymentMethodFilterOptions: ISelectOption<IPaymentMethodEntryTypeValue>[] = [
  { paymentMethod: eJournalEntryPaymentMethod.ACH, entryType: eJournalEntryType.CREDIT },
  { paymentMethod: eJournalEntryPaymentMethod.WIRE, entryType: eJournalEntryType.CREDIT },
  { paymentMethod: eJournalEntryPaymentMethod.CHECK, entryType: eJournalEntryType.CREDIT },
  { paymentMethod: eJournalEntryPaymentMethod.INTERNAL_TRANSFER, entryType: eJournalEntryType.CREDIT },
  { paymentMethod: eJournalEntryPaymentMethod.ACH, entryType: eJournalEntryType.DEBIT },
  { paymentMethod: eJournalEntryPaymentMethod.WIRE, entryType: eJournalEntryType.DEBIT },
  { paymentMethod: eJournalEntryPaymentMethod.CHECK, entryType: eJournalEntryType.DEBIT },
  { paymentMethod: eJournalEntryPaymentMethod.MANUAL_CHECK, entryType: eJournalEntryType.DEBIT },
  { paymentMethod: eJournalEntryPaymentMethod.INTERNAL_TRANSFER, entryType: eJournalEntryType.DEBIT },
].map((value) => ({
  value,
  label: getPaymentMethodLabel(value),
}));
